import { render, staticRenderFns } from "./project-site-view.vue?vue&type=template&id=252f2e24&scoped=true"
import script from "./project-site-view.vue?vue&type=script&lang=js"
export * from "./project-site-view.vue?vue&type=script&lang=js"
import style0 from "./project-site-view.vue?vue&type=style&index=0&id=252f2e24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252f2e24",
  null
  
)

export default component.exports